import React, { useState, useEffect } from 'react';
import '../css/Chiffres.css'; // Assurez-vous d'avoir ce fichier CSS pour les styles
import { Activity, Users, Heart, Handshake, Stethoscope, Target, Shield, Music, Sandwich, Beer, Droplets, CloudRain } from 'lucide-react';

const StatCard = ({ icon: Icon, number, unit, label, delay = 0, color }) => {
  const [displayNumber, setDisplayNumber] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Animation du compteur
      const duration = 2000;
      const steps = 60;
      const increment = number / steps;
      let current = 0;
      
      const counter = setInterval(() => {
        current += increment;
        if (current >= number) {
          setDisplayNumber(number);
          clearInterval(counter);
        } else {
          setDisplayNumber(Math.floor(current));
        }
      }, duration / steps);
      
      return () => clearInterval(counter);
    }, delay);
    
    return () => clearTimeout(timer);
  }, [number, delay]);

  return (
    // <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
    <div className="box-chiffre">
        <div className="box-chiffre-icon" style={{ background: `linear-gradient(135deg, ${color})` }}>
          <Icon size={30} className="text-white" />
        </div>
        <div className="box-chiffre-libs">
          <div className="text-4xl font-bold text-white">
            {displayNumber.toLocaleString()} {unit}
          </div>
          <div className="text-white/90 text-lg font-medium">
            {label}
          </div>
        </div>

    </div>
  );
};

const FloatingElement = ({ children, delay = 0 }) => {
  return (
    <div 
      className="animate-pulse"
      style={{
        animationDelay: `${delay}ms`,
        animationDuration: '3s'
      }}
    >
      {children}
    </div>
  );
};

export default function Chiffres() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showTitle, setShowTitle] = useState(false);

  useEffect(() => {
    setShowTitle(true);
  }, []);

  const stats = [
    {
      icon: CloudRain,
      number: 97929991,
      unit: "",
      label: "gouttes de pluie",
      color: "from-blue-500 to-purple-600",
      delay: 100
    },{
      icon: Activity,
      number: 21374,
      unit: "",
      label: "kms de parcourus",
      color: "from-blue-500 to-purple-600",
      delay: 200
    },
    {
      icon: Users,
      number: 2460,
      unit: "",
      label: "coureurs et marcheurs",
      color: "from-green-500 to-teal-600",
      delay: 400
    },
    {
        icon: Sandwich,
        number: 800,
        unit: "",
        label: "sandwichs",
        color: "from-amber-500 to-orange-600",
        delay: 600
      },
      {
        icon: Droplets,
        number: 450,
        unit: "",
        label: "litres d'eau",
        color: "from-cyan-500 to-blue-600",
        delay: 800
      },
      {
        icon: Beer,
        number: 300,
        unit: "",
        label: "litres de bière",
        color: "from-yellow-600 to-amber-700",
        delay: 1000
      },
  
    {
      icon: Heart,
      number: 250,
      unit: "",
      label: "bénévoles",
      color: "from-red-500 to-pink-600",
      delay: 1200
    },
    {
      icon: Handshake,
      number: 89,
      unit: "",
      label: "partenaires",
      color: "from-orange-500 to-yellow-600",
      delay: 1400
    },
    {
      icon: Stethoscope,
      number: 10,
      unit: "",
      label: "kinés et ostéos",
      color: "from-indigo-500 to-blue-600",
      delay: 1600
    },
    {
      icon: Shield,
      number: 8,
      unit: "",
      label: "secouristes",
      color: "from-emerald-500 to-green-600",
      delay: 1800
    },
    {
      icon: Music,
      number: 1,
      unit: "",
      label: "groupes de musique",
      color: "from-violet-500 to-purple-600",
      delay: 2000
    },
    {
      icon: Target,
      number: 1,
      unit: "",
      label: "cause",
      color: "from-purple-500 to-pink-600",
      delay: 0
    }
  ];

  return (
    <div className="">
    {/* <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden"> */}
      {/* Éléments de fond animés */}
      {/* <div className="absolute inset-0">
        <FloatingElement delay={0}>
          <div className="absolute top-20 left-10 w-20 h-20 bg-blue-500/20 rounded-full blur-xl"></div>
        </FloatingElement>
        <FloatingElement delay={1000}>
          <div className="absolute top-40 right-20 w-32 h-32 bg-purple-500/20 rounded-full blur-xl"></div>
        </FloatingElement>
        <FloatingElement delay={2000}>
          <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-pink-500/20 rounded-full blur-xl"></div>
        </FloatingElement>
      </div> */}

      {/* <div className="relative z-10 container mx-auto px-6 py-12"> */}
      <div className="">
        {/* Titre principal */}
        {/* <div className={`text-center mb-16 transform transition-all duration-1000 ${showTitle ? 'translate-y-0 opacity-100' : '-translate-y-8 opacity-0'}`}>
          <h1 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300 mb-4">
            Bilan Exceptionnel
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
          <p className="text-xl text-gray-300 mt-6 max-w-2xl mx-auto">
            Une mobilisation extraordinaire au service d'une noble cause
          </p>
        </div> */}

        {/* Grille des statistiques */}
        <div className="box-chiffres">
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-full mx-auto"> */}
          {stats.map((stat, index) => (
            <StatCard
              key={index}
              icon={stat.icon}
              number={stat.number}
              unit={stat.unit}
              label={stat.label}
              delay={stat.delay}
              color={stat.color}
            />
          ))}
        </div>

        {/* Section highlight pour "1 cause" */}
        {/* <div className="mt-16 text-center">
          <div className="transform transition-all duration-1000 delay-2500 translate-y-0 opacity-100">
            <div className="inline-block p-8 bg-gradient-to-r from-purple-600/30 to-pink-600/30 rounded-3xl backdrop-blur-sm border border-white/20">
              <h2 className="text-3xl font-bold text-white mb-4">
                Ensemble pour une cause qui nous unit tous
              </h2>
              <div className="flex justify-center space-x-4">
                <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce"></div>
                <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Footer */}
        {/* <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg">
            Merci à tous les participants, bénévoles et partenaires qui ont rendu cet événement possible
          </p>
        </div> */}
      </div>
    </div>
  );
}